<template>
  <ApplicationLayout>
    <div class="register-new">
      <div id="content">
        <div class="register">
          <div class="wrapper">
            <div class="inner">
              <div class="main">
                <h1 class="main-title">Registration</h1>
                <Form>
                  <validation-observer ref="form" v-slot="{ invalid }">
                    <sui-form
                      autocomplete="off"
                      enctype="multipart/form-data"
                      action="/recruiter_applications/confirm"
                      accept-charset="UTF-8"
                      method="post"
                    >
                      <input
                        type="hidden"
                        name="authenticity_token"
                        :value="csrfToken"
                      />
                      <RequiredText />
                      <div class="list">
                        <sui-form-field required>
                          <Label title="Name" :error="!isNameValid" />
                          <sui-form-fields fields="two">
                            <validation-provider
                              v-slot="{ errors }"
                              ref="firstNameProvider"
                              vid="firstName"
                              slim="slim"
                              name="First Name"
                              :rules="validationRules.firstName"
                            >
                              <sui-form-field :error="hasError(errors)">
                                <input
                                  v-model="recruiterApplication.firstName"
                                  type="text"
                                  name="recruiter_application[first_name]"
                                  placeholder="First Name"
                                  @input="onNameInput()"
                                />
                                <ErrorMessage :message="errors[0]" />
                              </sui-form-field>
                            </validation-provider>

                            <validation-provider
                              v-slot="{ errors }"
                              ref="lastNameProvider"
                              vid="lastName"
                              slim="slim"
                              name="Last Name"
                              :rules="validationRules.lastName"
                            >
                              <sui-form-field :error="hasError(errors)">
                                <input
                                  v-model="recruiterApplication.lastName"
                                  type="text"
                                  name="recruiter_application[last_name]"
                                  placeholder="Last Name"
                                  @input="onNameInput()"
                                />
                                <ErrorMessage :message="errors[0]" />
                              </sui-form-field>
                            </validation-provider>
                          </sui-form-fields>
                        </sui-form-field>

                        <validation-provider
                          v-slot="{ errors }"
                          vid="email"
                          slim="slim"
                          name="Email"
                          :rules="validationRules.email"
                        >
                          <sui-form-field required :error="hasError(errors)">
                            <Label title="Email" :error="hasError(errors)" />
                            <input
                              v-model="recruiterApplication.email"
                              type="email"
                              name="recruiter_application[email]"
                              placeholder="Enter your email"
                              @input="
                                recruiterApplication.email = recruiterApplication.email.toLowerCase()
                              "
                            />
                            <ErrorMessage :message="errors[0]" />
                          </sui-form-field>
                        </validation-provider>

                        <validation-provider
                          v-slot="{ errors }"
                          vid="userName"
                          slim="slim"
                          name="User Name"
                          :rules="validationRules.userName"
                        >
                          <sui-form-field required :error="hasError(errors)">
                            <Label
                              title="User Name (Nickname)"
                              :error="hasError(errors)"
                            />
                            <input
                              v-model="recruiterApplication.userName"
                              type="text"
                              name="recruiter_application[user_name]"
                              placeholder="Enter your user name"
                            />
                            <ErrorMessage :message="errors[0]" />
                          </sui-form-field>
                        </validation-provider>

                        <validation-provider
                          v-slot="{ errors }"
                          vid="linkedinUrl"
                          slim="slim"
                          name="LinkedIn URL"
                          :rules="validationRules.linkedinUrl"
                        >
                          <sui-form-field :error="hasError(errors)">
                            <Label
                              title="LinkedIn URL"
                              :error="hasError(errors)"
                            />
                            <input
                              v-model="recruiterApplication.linkedinUrl"
                              type="text"
                              name="recruiter_application[linkedin_url]"
                              placeholder="Please provide us your LinkedIn URL"
                            />
                            <ErrorMessage :message="errors[0]" />
                          </sui-form-field>
                        </validation-provider>

                        <validation-provider
                          v-slot="{ errors }"
                          vid="lineId"
                          slim="slim"
                          name="LINE ID"
                          :rules="validationRules.lineId"
                        >
                          <sui-form-field :error="hasError(errors)">
                            <Label title="LINE ID" :error="hasError(errors)" />
                            <input
                              v-model="recruiterApplication.lineId"
                              type="text"
                              name="recruiter_application[line_id]"
                              placeholder="Please provide us your LINE ID"
                            />
                            <ErrorMessage :message="errors[0]" />
                          </sui-form-field>
                        </validation-provider>

                        <validation-provider
                          v-slot="{ errors }"
                          vid="phoneNumber"
                          slim="slim"
                          name="Phone No."
                          :rules="validationRules.phoneNumber"
                        >
                          <sui-form-field :error="hasError(errors)">
                            <Label
                              title="Phone No."
                              :error="hasError(errors)"
                            />
                            <input
                              v-model="recruiterApplication.phoneNumber"
                              type="text"
                              name="recruiter_application[phone_number]"
                              placeholder="Enter your phone number"
                            />
                            <ErrorMessage :message="errors[0]" />
                          </sui-form-field>
                        </validation-provider>

                        <validation-provider
                          v-slot="{ errors }"
                          vid="recruiterExperience"
                          slim="slim"
                          name="Have you worked as a recruiter?"
                          :rules="recruiterExperienceValidationRule"
                        >
                          <sui-form-field required :error="hasError(errors)">
                            <Label
                              title="Have you worked as a recruiter?"
                              :error="hasError(errors)"
                            />
                            <sui-dropdown
                              v-model="recruiterApplication.recruiterExperience"
                              placeholder="Please select your experience"
                              selection
                              :options="recruiterExperienceOptions"
                            />
                            <input
                              type="hidden"
                              name="recruiter_application[recruiter_experience]"
                              :value="recruiterApplication.recruiterExperience"
                            />
                            <ErrorMessage :message="errors[0]" />
                          </sui-form-field>
                        </validation-provider>

                        <template v-if="hasRecruiterExperience">
                          <validation-provider
                            v-slot="{ errors }"
                            vid="recruiterTerm"
                            slim="slim"
                            name="How long have you been a recruiter?"
                            :rules="recruiterTermValidationRule"
                          >
                            <sui-form-field required :error="hasError(errors)">
                              <Label
                                title="How long have you been a recruiter?"
                                :error="hasError(errors)"
                              />
                              <sui-dropdown
                                v-model="recruiterApplication.recruiterTerm"
                                placeholder="Please select one answer"
                                selection
                                :options="recruiterTermOptions"
                              />
                              <input
                                type="hidden"
                                name="recruiter_application[recruiter_term]"
                                :value="recruiterApplication.recruiterTerm"
                              />
                              <ErrorMessage :message="errors[0]" />
                            </sui-form-field>
                          </validation-provider>

                          <validation-provider
                            v-slot="{ errors }"
                            vid="recruiterApplicationIndustries"
                            slim="slim"
                            name="Which industry are you specialized in?"
                            :rules="
                              validationRules.recruiterApplicationIndustries
                            "
                          >
                            <sui-form-field required :error="hasError(errors)">
                              <Label
                                title="Which industry are you specialized in?"
                                note="(Can select more than 1)"
                                :error="hasError(errors)"
                              />
                              <ul class="checkbox-group">
                                <li
                                  v-for="industryOption in industryOptions"
                                  :key="industryOption.value"
                                  class="item"
                                >
                                  <div class="ui checkbox" type="checkbox">
                                    <input
                                      v-model="
                                        recruiterApplication.recruiterApplicationIndustriesIndustryIds
                                      "
                                      :value="industryOption.value"
                                      name="recruiter_application[recruiter_application_industries_attributes][][industry_id]"
                                      type="checkbox"
                                    />
                                    <label>
                                      {{ industryOption.text }}
                                    </label>
                                  </div>
                                </li>
                              </ul>
                              <ErrorMessage :message="errors[0]" />
                            </sui-form-field>
                          </validation-provider>

                          <validation-provider
                            v-slot="{ errors }"
                            vid="recruiterApplicationCategories"
                            slim="slim"
                            name="Specialized Job Category"
                            :rules="
                              validationRules.recruiterApplicationCategories
                            "
                          >
                            <sui-form-field required :error="hasError(errors)">
                              <Label
                                title="Specialized Job Category"
                                :error="hasError(errors)"
                              />
                              <treeselect
                                ref="treeselect_category"
                                v-model="
                                  recruiterApplication.recruiterApplicationCategoriesCategoryIds
                                "
                                :multiple="true"
                                :options="categoryOptions"
                                value-consists-of="LEAF_PRIORITY"
                                :searchable="false"
                                :flatten-search-results="true"
                                :clear-on-select="false"
                                :max-height="500"
                                :limit="3"
                                :limit-text="treeselectLimitText"
                                placeholder="Select Job Category"
                              />
                              <input
                                v-for="categoryId in recruiterApplication.recruiterApplicationCategoriesCategoryIds"
                                :key="categoryId"
                                :value="categoryId"
                                :name="`recruiter_application[recruiter_application_categories_attributes][][category_id]`"
                                type="hidden"
                              />
                              <ErrorMessage :message="errors[0]" />
                            </sui-form-field>
                          </validation-provider>
                        </template>

                        <input
                          v-model="recruiterApplication.cachedCvData"
                          type="hidden"
                          name="recruiter_application[cv]"
                        />

                        <validation-provider
                          v-slot="{ validate, errors }"
                          ref="cvProvider"
                          vid="cv"
                          slim="slim"
                          name="CV upload"
                          :rules="validationRules.cv"
                        >
                          <sui-form-field
                            class="upload-button"
                            :error="hasError(errors)"
                          >
                            <Label
                              title="CV Upload"
                              :error="hasError(errors)"
                            />
                            <InputFile
                              :cached-file-data="
                                recruiterApplication.cachedCvData
                              "
                              name="recruiter_application[cv]"
                              @file-selected="validate"
                            />
                            <ErrorMessage :message="errors[0]" />
                            <div class="note">
                              Only .pdf and less than 10MB files are accepted
                            </div>
                          </sui-form-field>
                        </validation-provider>

                        <validation-provider
                          v-slot="{ errors }"
                          vid="refererId"
                          slim="slim"
                          name="How did you hear about SourcedOut?"
                          :rules="refererIdValidationRule"
                        >
                          <sui-form-field required :error="hasError(errors)">
                            <Label
                              title="How did you hear about SourcedOut?"
                              :error="hasError(errors)"
                            />
                            <sui-dropdown
                              v-model="recruiterApplication.refererId"
                              placeholder="Select source"
                              selection
                              :options="refererIdOptions"
                            />
                            <input
                              type="hidden"
                              name="recruiter_application[referer_id]"
                              :value="recruiterApplication.refererId"
                            />
                            <ErrorMessage :message="errors[0]" />
                          </sui-form-field>
                        </validation-provider>

                        <SubmitButton :disabled="invalid" label="Confirm">
                          <template #remark>
                            <p>
                              Already have an account?
                              <a class="link" href="/users/sign_in"> Log in </a>
                            </p>
                          </template>
                        </SubmitButton>
                      </div>
                    </sui-form>
                  </validation-observer>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ApplicationLayout>
</template>

<script>
import Vue from 'vue'
import SuiVue from 'semantic-ui-vue'
Vue.use(SuiVue)

import isURL from 'validator/lib/isURL'
import { extend, ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, max, regex, ext, size, oneOf } from 'vee-validate/dist/rules'
extend('required', required)
extend('max', max)
extend('regex', regex)
extend('ext', ext)
extend('size', size)
extend('oneOf', oneOf)
extend('url', {
  validate: (value) => {
    return isURL(value)
  },
  message: (field) => {
    return `${field} must be a URL.`
  },
})

const validationRules = {
  firstName: 'required|max:255',
  lastName: 'required|max:255',
  userName: 'required|max:255',
  email: 'required|emailEnglishNoSpace|max:255',
  linkedinUrl: 'url|max:255',
  lineId: { max: 30, regex: /^@?[0-9a-zA-Z._-]+$/ },
  phoneNumber: 'max:15|regex:^[0-9+]+$',
  recruiterApplicationIndustries: 'required',
  recruiterApplicationCategories: 'required',
  cv: 'ext:pdf|size:10240',
}

import ApplicationLayout from 'components/layouts/Application.vue'
import Form from 'components/ui/form/Form.vue'
import ErrorMessage from 'components/ui/form/ErrorMessage.vue'
import Label from 'components/ui/form/Label.vue'
import InputFile from 'components/ui/form/InputFile.vue'
import SubmitButton from 'components/ui/form/SubmitButton.vue'
import RequiredText from 'components/views/recruiterApplications/RequiredText.vue'

import utils from 'mixins/utils'
import isEmpty from 'lodash/isEmpty'

import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

const ViewProps = window._application.props

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    ApplicationLayout,
    Form,
    ErrorMessage,
    Label,
    InputFile,
    SubmitButton,
    RequiredText,
    Treeselect,
  },

  mixins: [utils],

  data() {
    const form = ViewProps.recruiterApplicationForm

    return {
      csrfToken: ViewProps.csrfToken,
      validationRules: validationRules,
      recruiterApplication: form.recruiterApplication,
      recruiterExperienceOptions: form.recruiterExperienceOptions,
      recruiterTermOptions: form.recruiterTermOptions,
      industryOptions: form.industryOptions,
      categoryOptions: form.categoryOptions,
      refererIdOptions: form.refererIdOptions,
      backendErrors: form.errors,
      isNameValid: true,
    }
  },

  computed: {
    recruiterExperienceOptionValues: function () {
      return this.recruiterExperienceOptions.map((elm) => elm.value)
    },

    recruiterExperienceValidationRule: function () {
      return 'required|oneOf:' + this.recruiterExperienceOptionValues.join(',')
    },

    hasRecruiterExperience: function () {
      const value = this.recruiterApplication.recruiterExperience
      return value && value !== 'non_hr_recruiter'
    },

    recruiterTermOptionValues: function () {
      return this.recruiterTermOptions.map((elm) => elm.value)
    },

    recruiterTermValidationRule: function () {
      return 'oneOf:' + this.recruiterTermOptionValues.join(',')
    },

    refererIdOptionValues: function () {
      return this.refererIdOptions.map((elm) => elm.value)
    },

    refererIdValidationRule: function () {
      return 'required|oneOf:' + this.refererIdOptionValues.join(',')
    },
  },

  mounted: function () {
    this.$refs.form.setErrors(this.backendErrors)
    this.$refs.form.validate({ silent: true })
    this.setIsNameValid()
  },

  methods: {
    async onNameInput() {
      await this.$refs.firstNameProvider.validate()
      await this.$refs.lastNameProvider.validate()
      this.setIsNameValid()
    },

    setIsNameValid() {
      this.isNameValid =
        isEmpty(this.$refs.firstNameProvider.errors) &&
        isEmpty(this.$refs.lastNameProvider.errors)
    },

    treeselectLimitText() {
      return '...'
    },
  },
}
</script>

<style scoped lang="scss">
@import 'stylesheets/global';

.main-title {
  @include text-main-title;
}

.note {
  @include text-note;
}

::v-deep .vue-treeselect {
  border: 1px solid $black;

  /* stylelint-disable selector-class-pattern */
  .vue-treeselect__control {
    border: 0;
    height: 40px;

    .vue-treeselect__control-arrow {
      color: $black;
    }

    .vue-treeselect__value-container {
      overflow: clip;

      .vue-treeselect__multi-value {
        display: flex;
        flex-wrap: nowrap;
        margin-bottom: 0;
        pointer-events: none;

        .vue-treeselect__input-container {
          font-size: 0;

          .vue-treeselect__input {
            background: none transparent;
            border: 0;
            box-shadow: none;
            box-sizing: content-box;
            line-height: 1;
            margin: 0;
            max-width: 100%;
            outline: none;
            padding: 0;
            vertical-align: middle;
          }
        }

        .vue-treeselect__limit-tip {
          padding-left: 3px;

          .vue-treeselect__limit-tip-text {
            color: black;
          }
        }
      }

      .vue-treeselect__multi-value-item-container {
        padding-right: 0;
      }

      .vue-treeselect__multi-value-item {
        display: contents;

        .vue-treeselect__multi-value-label {
          color: $black;
          font-size: 15px;
          padding: 0;
          padding-left: 2px;
          padding-right: 2px;
          white-space: nowrap;

          &:first-child {
            padding-bottom: 4.5px;
            padding-left: 5px;
          }

          &::after {
            color: $black;
            content: ',';
            position: absolute;
            top: 10;
          }
        }

        .vue-treeselect__value-remove {
          display: none;
        }
      }
    }

    .vue-treeselect__x-container {
      color: #ccc;

      &:hover {
        color: #a6a6a6;
      }
    }
  }

  /* stylelint-enable selector-class-pattern */
}

/* stylelint-disable selector-class-pattern */
::v-deep .vue-treeselect__placeholder {
  color: $placeholder;
  font-size: 14px;
  line-height: 40px;
}
/* stylelint-enable selector-class-pattern */

/* stylelint-disable selector-class-pattern */
::v-deep .vue-treeselect__menu-container {
  top: 130%;

  .vue-treeselect__menu {
    background: white;
    border: 1px solid #ddd;
    border-radius: 10px;
    box-shadow: rgba(149, 157, 165, 0.2) 0 8px 24px;
    color: $black;
    font-size: 16px;
    padding: 1rem 1rem;

    .vue-treeselect__checkbox,
    .vue-treeselect__checkbox--indeterminate {
      background-position: auto auto;
      height: 20px;
      width: 20px;
    }

    .vue-treeselect__check-mark,
    .vue-treeselect__minus-mark {
      background-size: 10px 10px;
      height: 10px;
      left: 4px;
      position: absolute;
      top: 4px;
      width: 10px;
    }

    .vue-treeselect__checkbox--checked {
      background: #3742fa;
      border-color: #3742fa;
    }

    .vue-treeselect__checkbox--unchecked {
      background: white;
      border-color: rgb(204, 204, 204);
    }

    //Parent Checkbox with Minus
    .vue-treeselect__checkbox--indeterminate {
      background: white;
      border-color: rgb(204, 204, 204);
    }

    //Parent Label
    .vue-treeselect__indent-level-0 {
      label.vue-treeselect__label {
        font-weight: 16px;
        font-weight: 500;
      }

      .vue-treeselect__option {
        margin-bottom: 0.85rem;
      }

      .vue-treeselect__indent-level-1 {
        label.vue-treeselect__label {
          font-size: 16px;
          font-weight: 400;
        }

        .vue-treeselect__option {
          margin-bottom: 5px;
        }

        .vue-treeselect__checkbox--checked {
          label.vue-treeselect__label {
            font-weight: 600;
          }
        }
      }
    }

    .vue-treeselect__label {
      font-weight: 600;
    }

    //Child Label
    .vue-treeselect__list {
      .vue-treeselect__label {
        font-weight: normal;
      }
    }

    .vue-treeselect__option--selected {
      font-weight: 700;
    }
  }
}
/* stylelint-enable selector-class-pattern */
</style>
